<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <circle cx="8" cy="8" r="6.25" />
        <path d="M5.5 8l2 2 3-4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'SuccessIcon' });
</script>
